import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertySpecialFeatures, PropertySpecialFeaturesSplitted } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const SpecialFeaturesWrapper = ({
  inputs,
  columns
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement("div", null, React.createElement(PropertySpecialFeatures, {
    inputs: inputs,
    columns: columns,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement("div", null, React.createElement(PropertySpecialFeaturesSplitted, {
    inputs: inputs,
    columns: columns,
    skipSsr: cSRPropertyDetailsQuery
  })))));
};
export const SharedUiSpecialFeaturesWrapper = withSharedUiPropertyDetails(SpecialFeaturesWrapper);
SharedUiSpecialFeaturesWrapper.displayName = 'SharedUiSpecialFeaturesWrapper';